import React from 'react';
import './Burgular.css';
import FMSimage from '../Assets/bur2.jpeg'; // First image (full size)
import FMSimage2 from '../Assets/burgular2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/burgular3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/bur1 (2).jpeg'; // Image for Why Choose section
import FMSimage5 from '../Assets/burgular5.jpg'; // Image for Industries section

const Burgular = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">Burglar Alarm System</h1>
                    <p className="FMS-description">
                        Burglar Alarm Systems are designed to detect unauthorized entry into a building or area. These systems utilize motion sensors, door/window contacts, and alarm triggers to alert homeowners or security personnel in case of intrusion. Integrated with smart technology, these systems provide real-time alerts and remote monitoring capabilities.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Burglar Alarm System" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Burglar Alarm System offers enhanced security through real-time monitoring, instant alerts, and automated response mechanisms. Features include motion detection, tamper-proof design, and seamless integration with smart home systems, ensuring complete protection.
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        The system continuously monitors entry points using advanced sensors. If unauthorized access is detected, an alert is triggered, notifying the user through a mobile app or security service. The system can also be integrated with CCTV for enhanced surveillance.
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Burglar Alarm System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Burglar Alarm System provides comprehensive security with high accuracy and reliability. Key benefits include:
                        <ul>
                            <li>Instant alerts and notifications</li>
                            <li>Seamless integration with smart home security</li>
                            <li>24/7 monitoring with real-time updates</li>
                            <li>Customizable alarm settings and zones</li>
                            <li>Remote access via mobile application</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Burglar Alarm System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using Burglar Alarm System" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Burglar Alarm System is widely used across various industries to ensure security and prevent unauthorized access. Key industries benefiting from this solution include:
                        <ul>
                            <li>Residential Buildings & Apartments</li>
                            <li>Commercial Offices & Warehouses</li>
                            <li>Retail Stores & Shopping Malls</li>
                            <li>Industrial Facilities & Factories</li>
                            <li>Banks & Financial Institutions</li>
                            <li>Educational Institutions & Campuses</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Burgular;
